"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var next_components_1 = require("@dotdev/next-components");
var Snippets = require("snippets");
var click_and_collect_1 = require("./click-and-collect");
var ProductFindInStore = /** @class */ (function (_super) {
    __extends(ProductFindInStore, _super);
    function ProductFindInStore(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClick = function (event) {
            _this.props.toggle();
        };
        _this.state = {};
        return _this;
    }
    ProductFindInStore.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: "w-full" },
            React.createElement("div", { className: "w-full flex justify-between items-center mt-0-8 py-2-4 border-t border-blue-grey" },
                React.createElement("div", { className: "flex " + (this.props.cncStore ? "items-center" : "items-start") },
                    React.createElement("div", { className: "mr-1" },
                        React.createElement(Snippets.Svg, { name: "bag", height: 20 })),
                    React.createElement("div", { className: "flex items-start justify-start flex-wrap" },
                        React.createElement("span", { className: "text-midnight font-semibold text-sm" }, "Click & Collect"),
                        this.props.cncStore ? (React.createElement(React.Fragment, null,
                            React.createElement("p", { className: "font-sans " + (this.props.available ? "text-green" : "text-red") + " text-sm leading-normal flex items-center justify-start w-full" },
                                React.createElement("span", { className: "text-midnight font-semibold" }, this.props.cncStore),
                                React.createElement("span", { className: "relative h-1-6 w-1-6 " + (this.props.available ? "bg-green" : "bg-red") + " rounded-half mx-0-4" },
                                    React.createElement(Snippets.Svg, { name: this.props.available ? "check" : "clear", width: 16, className: "text-arctic absolute transform" })),
                                React.createElement("span", { className: "text-midnight font-semibold" }, this.props.available ? "In stock" : "Unavailable")))) : null)),
                React.createElement("div", { className: "text-xs text-midnight underline cursor-pointer", onClick: function (event) { return _this.handleClick(event); } }, this.props.text ? this.props.text : "Find In Store")),
            React.createElement(click_and_collect_1.default, __assign({ variants: [this.props.variant], toggle: this.props.toggle, show: this.props.show }, this.props, { updateStore: this.props.updateStore }))));
    };
    ProductFindInStore.contextType = next_components_1.ShopifyNext.Context;
    return ProductFindInStore;
}(React.PureComponent));
exports.ProductFindInStore = ProductFindInStore;
exports.default = ProductFindInStore;
